import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import CustomLoader from '../../common/CustomLoader';
import { drapcodeIcon, iconForField } from '../../../common/custom/icon-library';

export default class CustomJSCDNForm extends Component {
  static propTypes = {
    handleCustomJsCdnSubmit: PropTypes.func.isRequired,
  };
  state = {
    enableAddJsCdn: false,
  };

  clearForm = () => {
    this.setState({
      schema: {},
      enableAddJsCdn: false,
    });
  };

  validateUrl = (value) => {
    if (!value || value.length === 0) {
      this.setState({ enableAddJsCdn: false });
      return 'URL or a <script> tag is required';
    }

    const urlRegEx =
      /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;

    if (!urlRegEx.test(value)) {
      if (!value.startsWith('<script') || !value.includes('src') || !value.endsWith('</script>')) {
        this.setState({ enableAddJsCdn: false });
        return 'Not a valid URL or a <script> tag';
      }
    }

    this.setState({ enableAddJsCdn: true });
  };

  validateSortOrder = (value) => {
    const numberRegEx = /^\d+$/;
    if (value && !numberRegEx.test(value)) {
      this.setState({ enableAddJsCdn: false });
      return 'Sort Order value is not valid';
    }
  };

  createSchemaCustomJSCdn = () => {
    const { customJsCdns, customJsCdnUuid } = this.props;

    let customJsCdn =
      customJsCdns && customJsCdns.find((customJsCdn) => customJsCdn.uuid === customJsCdnUuid);
    let schema = {};
    schema['customJsUrlOrTag'] = customJsCdn ? customJsCdn.urlOrTag : '';
    schema['loadToBuilder'] = customJsCdn ? customJsCdn.loadToBuilder : true;
    schema['sortOrder'] = customJsCdn ? customJsCdn.sortOrder : '';
    schema['addToHead'] = customJsCdn ? customJsCdn.addToHead : '';
    return schema;
  };

  handleJsCdnSubmit = (values) => {
    const { customJsCdnUuid } = this.props;

    const customJsCDNsFlattenContent =
      values && values.customJsUrlOrTag ? values.customJsUrlOrTag.trim() : '';
    const customType = customJsCDNsFlattenContent.startsWith('<script') ? 'TAG' : 'URL';
    if (customJsCdnUuid) {
      this.props.handleCustomJsCdnSubmit({
        customJsUrlOrTag: customJsCDNsFlattenContent,
        loadToBuilder: values.loadToBuilder,
        sortOrder: values.sortOrder ? values.sortOrder : 0,
        addToHead: values.addToHead,
        uuid: customJsCdnUuid,
        customType,
      });
    } else {
      this.props.handleCustomJsCdnSubmit({
        customJsUrlOrTag: customJsCDNsFlattenContent,
        loadToBuilder: values.loadToBuilder,
        sortOrder: values.sortOrder ? values.sortOrder : 0,
        addToHead: values.addToHead,
        customType,
      });
    }
  };

  render() {
    const { showCustomJSCDNLoader, isJsCdnCreate, isReadOnly } = this.props;

    return (
      <>
        <Formik
          initialValues={this.createSchemaCustomJSCdn()}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            !isReadOnly && this.handleJsCdnSubmit(values);
            setSubmitting(false);
            resetForm();
            this.clearForm();
            this.props.closeNewCustomJsCdn();
          }}
        >
          {({ isSubmitting, setFieldValue, setFieldTouched, resetForm, errors }) => {
            return (
              <Form className="form-horizontal">
                <div className="row mx-auto">
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <div className="input-group">
                        <div
                          className="input-group-prepend"
                          title="JavaScript URL or a <script> tag"
                        >
                          <span className="input-group-text">
                            <i className={`wb ${iconForField('url')}`}></i>
                            <span className="required"> *</span>
                          </span>
                        </div>
                        <Field
                          name="customJsUrlOrTag"
                          className="form-control form-control-sm"
                          placeholder="Insert your JavaScript URL or a <script> tag here.."
                          validate={this.validateUrl}
                        />
                        <ErrorMessage name="customJsUrlOrTag">
                          {(msg) => <p className="text-error">{msg}</p>}
                        </ErrorMessage>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-6 col-sm-6 col-xs-12">
                    <div className="form-group">
                      <div className="input-group">
                        <div className="input-group-prepend" title="Load to Builder Canvas">
                          <span className="input-group-text">
                            <i className={`wb ${iconForField('boolean-toggle')}`}></i>
                            <span className="required"> *</span>
                          </span>
                        </div>

                        <div className="form-check">
                          <label className="form-check-label">
                            <Field
                              type="checkbox"
                              name="loadToBuilder"
                              className="form-check-input"
                              title={isReadOnly ? 'Read-Only Mode' : 'Load to Builder Canvas'}
                              disabled={isReadOnly}
                            />
                            Load to Builder Canvas
                            <span className="form-check-sign">
                              <span className="check"></span>
                            </span>
                          </label>
                          <p className="errors">
                            <ErrorMessage name="loadToBuilder" />
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-6 col-sm-6 col-xs-12">
                    <div className="form-group">
                      <div className="input-group">
                        <div className="input-group-prepend" title="Add to Head">
                          <span className="input-group-text">
                            <i className={`wb ${iconForField('boolean-toggle')}`}></i>
                            <span className="required"> *</span>
                          </span>
                        </div>

                        <div className="form-check">
                          <label className="form-check-label">
                            <Field
                              type="checkbox"
                              name="addToHead"
                              className="form-check-input"
                              title={isReadOnly ? 'Read-Only Mode' : 'Add to Head'}
                              disabled={isReadOnly}
                            />
                            Add to Head (Default location: Body)
                            <span className="form-check-sign">
                              <span className="check"></span>
                            </span>
                          </label>
                          <p className="errors">
                            <ErrorMessage name="addToHead" />
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-6 col-sm-6 col-xs-12">
                    <div className="form-group">
                      <div className="input-group">
                        <div className="input-group-prepend" title="Order">
                          <span className="input-group-text">
                            <i className={`wb ${iconForField('number')}`}></i>
                            <span className="required"> *</span>
                          </span>
                        </div>
                        <Field
                          name="sortOrder"
                          className="form-control form-control-sm"
                          placeholder="Sort Order value (Default: 0)"
                          validate={this.validateSortOrder}
                        />
                        <ErrorMessage name="sortOrder">
                          {(msg) => <p className="text-error">{msg}</p>}
                        </ErrorMessage>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 col-lg-12 text-right">
                    <button
                      type="reset"
                      className="btn btn-default btn-md"
                      onClick={() => {
                        resetForm();
                        this.props.closeNewCustomJsCdn();
                      }}
                    >
                      <span>
                        <i className={`wb ${drapcodeIcon('cancel')}`}></i>&nbsp;Cancel
                      </span>
                    </button>
                    &nbsp;
                    {isJsCdnCreate ? (
                      <button
                        type={`${this.state.enableAddJsCdn ? 'submit' : 'button'}`}
                        className={`btn btn-md ${
                          this.state.enableAddJsCdn ? 'btn-theme-submit' : 'btn-default disabled'
                        }`}
                        disabled={
                          (isSubmitting && showCustomJSCDNLoader) || isReadOnly ? 'disabled' : ''
                        }
                        title={isReadOnly ? 'Read-Only Mode' : 'Add JavaScript URL/Script Tag'}
                      >
                        <i className={`wb ${drapcodeIcon('create')}`}></i>&nbsp;
                        {isJsCdnCreate ? 'Add' : 'Update'} JavaScript URL/Script Tag&nbsp;
                        <CustomLoader loading={showCustomJSCDNLoader} />
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="btn btn-theme-submit btn-md"
                        disabled={
                          (isSubmitting && showCustomJSCDNLoader) || isReadOnly ? 'disabled' : ''
                        }
                        title={isReadOnly ? 'Read-Only Mode' : 'Update JavaScript URL/Script Tag'}
                      >
                        <i className={`wb ${drapcodeIcon('update')}`}></i>&nbsp;Update
                        <CustomLoader loading={showCustomJSCDNLoader} />
                      </button>
                    )}
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </>
    );
  }
}
